import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { Order } from '../models';

@Component({
  selector: 'app-pay-return',
  templateUrl: './pay-return.component.html',
  styleUrls: ['./pay-return.component.scss']
})
export class PayReturnComponent implements OnInit {

  orderId: string = ''
  constructor(
    private route: ActivatedRoute,
    private auth: AuthService,
    private router: Router

  ) { }

  async ngOnInit(): Promise<void> {
    const qPM = this.route.snapshot.queryParamMap;
    await this.auth.connectClient();
    // const orderId = qPM.get('OrderID').slice(-17).replace('_',':'); // 17 -> timestamp+:+3 letters order ID
    this.orderId = qPM.get('OrderID').split('-').slice(1).join(':')

    await this.goToOrder(this.orderId);
  }

  async goToOrder(orderId:string) {
    const locOrders = await this.auth.getAllOrdersFromLocalDB();
    const ord = locOrders.filter((o) => o._id.endsWith(orderId))[0];
    this.router.navigateByUrl(`/in/${ord.restId}/${ord.tableId}/${ord._id}`);
  }
}
